import * as d3 from 'd3'
export default {
  methods: {

   draw_DataGrid() {

      let tbl = this.table
      
      let table = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.header.y + this.header.height})`)

      let y_ = 12
      this.tblData.forEach((d,i)=> {

        this.columns.forEach((col,c)=> {
          if(c<3) return 
          let alpha = 1+col.tSize*0.26
          

          if(col.unit) {
            let color = ''
            let val = (d[col.code] * 100)
            if(this.tblData[0].DISC == 'STRUCTURE') {
              if(val < 0.24) color = this.rate.green
              if(val > 0.3) color = this.rate.red
              if(val >= 0.24 && val <= 0.3) color = this.rate.yellow
            }
            if(this.tblData[0].DISC == 'PIPING') {
              if(val < 2) color = this.rate.green
              if(val > 2.5) color = this.rate.red
              if(val >= 2 && val <= 2.5) color = this.rate.yellow
            }

            table
            .append('rect')
            .attr('x', col.sx).attr('y', y_-9)
            .attr('width', col.width).attr('height', 18)
            .attr('fill', color)
            .attr('opacity', ()=> {
              let rate = 0
              if (col.code == 'WK_RATE' && d.WK_JOINT > 0) rate = 0.5
              if (col.code == 'CUM_RATE' && d.CUM_TEST > 0) rate = 0.5
              return rate
            })

            table
            .append('text')
            .attr('x', col.tx).attr('y', y_+alpha)
            .attr('font-size', col.tSize)
            .attr('fill', d.group ? '#000' : col.tColor)
            .attr('text-anchor', col.align)
            .text(()=> {
              let rate = ''
              if (col.code == 'WK_RATE' && d.WK_JOINT > 0) rate = val.toFixed(2) + col.unit
              if (col.code == 'CUM_RATE' && d.CUM_TEST > 0) rate = val.toFixed(2) + col.unit
              return rate
            })
          } else {
            table
            .append('text')
            .attr('x', col.tx).attr('y', y_+alpha)
            .attr('font-size', col.tSize)
            .attr('fill', d.group ? '#000' : col.tColor)
            .attr('text-anchor', col.align)
            .text(()=> {
              let val = '-'
              if (c<6 && d.WK_JOINT > 0) val = d[col.code].toLocaleString()
              if (c>6 && d.CUM_JOINT > 0) val = d[col.code].toLocaleString()
              return val
            })
          }

        })

        y_ = y_ + tbl.lineHeight
      })




      table
      .append('line')
      .attr('x1', 0).attr('y1', y_+10-tbl.lineHeight)
      .attr('x2', tbl.width).attr('y2', y_+10-tbl.lineHeight)
      .attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', 1)

    },


  }
}